module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hrms62e-popup",
      "id": "hrms62e-popup",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRMS62EC3']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS62EC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.codleave) + " - " + _vm._s(_vm.data.desc_codleave))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS62EC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.data.desc_flgchol))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS62EC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.condition),
      expression: "data.condition"
    }],
    staticClass: "form-control readonly-field-color",
    domProps: {
      "value": (_vm.data.condition)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "condition", $event.target.value)
      }
    }
  })])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6387136f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms62e/popup.vue
// module id = 3820
// module chunks = 1